import Swiper, { Pagination, Autoplay, EffectFade } from 'swiper';
import 'swiper/swiper-bundle.css';

window.addEventListener('load', () => {
  const advisorsSlider = document.querySelectorAll('.advisors');
  if (advisorsSlider.length > 0) {
    advisorsSlider.forEach((element) => {
      const swiper = new Swiper(element.querySelector('.advisors-swiper'), {
        modules: [Pagination, EffectFade, Autoplay],
        slidesPerView: '1',
        spaceBetween: 50,
        autoplay: {
          delay: 5000,
        },
        pauseOnMouseEnter : true,
        speed: 1000,
        breakpoints: {
          1024: {
            slidesPerView: 3,
          },
          769: {
            slidesPerView: 2,
          },
        },
        pagination: {
          el: element.querySelector('.advisors__swiper-pagination'),
          clickable: true,
        },
      });

      swiper.init();
    })
  }
});
